/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Starter_6Inputs */



/**
* | output |
* | --- |
* | "Export transcripts (DocX, and CSV)" |
*
* @param {Signup_Feature_Starter_6Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_starter_6 = /** @type {((inputs?: Signup_Feature_Starter_6Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Starter_6Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Export transcripts (DocX, and CSV)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export transcripts (DocX, and CSV)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Export transcripts (DocX, and CSV)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Export transcripts (DocX, and CSV)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Export transcripts (DocX, and CSV)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Export transcripts (DocX, and CSV)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Export transcripts (DocX, and CSV)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Export transcripts (DocX, and CSV)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Export transcripts (DocX, and CSV)")
	return /** @type {LocalizedString} */ ("Export transcripts (DocX, and CSV)")
});